export var ERROR_BOUNDARY = {
    OK: 'ok',
    PERMISSIONS_ERROR: 'permissions_error',
    APP_CRASH: 'app_crash',
    TOKEN_EXPIRED: 'token_expired',
};
